/* PDI Personalizzatore — JS God Mode v4.9 (WhatsApp Product Title Included) */

document.addEventListener('DOMContentLoaded', () => {
  
  function triggerHaptic() {
    if (navigator.vibrate) { navigator.vibrate(40); }
  }

  const DOM = {
    cartLoader: document.getElementById('pdiCartLoader'),
    variantsData: document.getElementById('pdiProductData'),
    optionsData: document.getElementById('pdiOptionsData'),
    tiersDataMeta: document.querySelector('meta[name="pdi-tiers-data"]'),
    extraFeeMeta: document.querySelector('meta[name="pdi-extra-fee"]'), 
    productTitleMeta: document.querySelector('meta[name="pdi-product-title"]'),
    globalQtyInput: document.getElementById('pdiGlobalQtyInput'),
    minOrderNotice: document.getElementById('pdiMinOrderNotice'),
    builderContainer: document.getElementById('pdiBuilderContainer'),
    addRowBtn: document.getElementById('pdiAddRowBtn'),
    unitPriceEl: document.getElementById('pdiUnitPrice'),
    totalPriceEl: document.getElementById('pdiTotalPrice'),
    addBtn: document.getElementById('pdiAddBtn'),
    mainImage: document.getElementById('pdiMainImg'),
    drawer: document.getElementById('pdiDrawer'),
    progressBar: document.getElementById('pdiProgressBar'),
    posInput: document.getElementById('pdiPrintPosition'),
    errorBox: document.getElementById('pdiErrorMsg'),
    variantInput: document.getElementById('pdiVariantId'),
    badgesContainer: document.getElementById('pdiDrawerBadges')
  };

  if (!DOM.variantsData || !DOM.optionsData) return;
  
  let variants = [];
  let productOptions = [];
  try { 
    variants = JSON.parse(DOM.variantsData.textContent); 
    productOptions = JSON.parse(DOM.optionsData.textContent);
  } catch(e) { return; }
  
  let basePrice = variants[0] && variants[0].price ? variants[0].price / 100 : 0; 
  let priceTiers = [];
  
  let calculatedUnitPrice = basePrice;
  let calculatedTotalPrice = 0;
  
  if (DOM.tiersDataMeta && DOM.tiersDataMeta.content && DOM.tiersDataMeta.content.includes(':')) {
    const rawData = DOM.tiersDataMeta.content.trim();
    const parts = rawData.split('|');
    parts.forEach(part => {
      const splitPart = part.split(':');
      if (splitPart.length === 2) {
        const qtyNum = parseInt(splitPart[0].trim(), 10);
        const priceNum = parseFloat(splitPart[1].trim().replace(',', '.'));
        if (!isNaN(qtyNum) && !isNaN(priceNum)) { priceTiers.push({ qty: qtyNum, price: priceNum }); }
      }
    });
    priceTiers.sort((a, b) => b.qty - a.qty);
  }

  let minQty = 1;
  if (priceTiers.length > 0) { minQty = priceTiers[priceTiers.length - 1].qty; }
  
  if(DOM.globalQtyInput) {
    DOM.globalQtyInput.value = 0; 
    if(DOM.minOrderNotice) {
      DOM.minOrderNotice.style.display = 'none'; 
    }
  }

  let colorOptionName = '';
  let colorOptionValues = [];
  let sizeOptions = []; 

  productOptions.forEach((opt) => {
    const oName = opt.name.toLowerCase();
    if(oName === 'title') return; 
    
    if(oName.includes('color') || oName.includes('colore')) {
      colorOptionName = opt.name;
      colorOptionValues = opt.values.map(v => v.trim()).filter(v => v !== "");
    } else {
      sizeOptions.push({
        name: opt.name,
        values: opt.values.map(v => v.trim()).filter(v => v !== "")
      });
    }
  });

  function formatEuro(value) {
    if(isNaN(value)) value = 0;
    return '€' + Number(value).toFixed(2).replace('.', ',');
  }

  function getTotalQuantity() {
    let total = 0;
    if (DOM.builderContainer) {
      document.querySelectorAll('.pdi-dp-builder-row').forEach(row => {
        let rowMax = 0;
        const subSections = row.querySelectorAll('.pdi-dp-size-sub-section');
        subSections.forEach(section => {
          let sectionSum = 0;
          section.querySelectorAll('.pdi-dp-row-qinput').forEach(inp => {
            let val = parseInt(inp.value, 10);
            if(!isNaN(val) && val > 0) sectionSum += val;
          });
          if (sectionSum > rowMax) rowMax = sectionSum;
        });
        total += rowMax;
      });
    }
    
    if (total === 0 && DOM.globalQtyInput) total = parseInt(DOM.globalQtyInput.value, 10) || 0;
    if (total === 0) total = minQty;
    
    return total;
  }

  function syncGlobalTotal() {
    let total = getTotalQuantity();
    if(DOM.globalQtyInput) {
      DOM.globalQtyInput.value = total;
      
      if (DOM.minOrderNotice) {
        if (total >= minQty) {
          DOM.minOrderNotice.style.display = 'none';
        } else {
          DOM.minOrderNotice.style.display = 'inline-block';
        }
      }
    }
    calculatePrice();
  }

  const globalPlusBtn = document.getElementById('globalPlus');
  const globalMinusBtn = document.getElementById('globalMinus');

  if(globalPlusBtn) {
    globalPlusBtn.addEventListener('click', () => {
      triggerHaptic();
      const firstRow = document.querySelector('.pdi-dp-builder-row');
      if(firstRow) {
        firstRow.querySelectorAll('.pdi-dp-size-sub-section').forEach(sub => {
          const firstInput = sub.querySelector('.pdi-dp-row-qinput');
          if(firstInput) firstInput.value = parseInt(firstInput.value, 10) + 1;
        });
        syncGlobalTotal();
      } else if (DOM.globalQtyInput) {
        DOM.globalQtyInput.value = parseInt(DOM.globalQtyInput.value, 10) + 1;
        syncGlobalTotal();
      }
    });
  }

  if(globalMinusBtn) {
    globalMinusBtn.addEventListener('click', () => {
      triggerHaptic();
      let currentTotal = getTotalQuantity();
      if(currentTotal <= minQty) {
        showError(`⚠️ Il minimo d'ordine è di ${minQty} pezzi.`);
        return;
      }

      const firstRow = document.querySelector('.pdi-dp-builder-row');
      if(firstRow) {
        firstRow.querySelectorAll('.pdi-dp-size-sub-section').forEach(sub => {
          const inputs = Array.from(sub.querySelectorAll('.pdi-dp-row-qinput')).reverse();
          for(let inp of inputs) {
            let val = parseInt(inp.value, 10);
            if(val > 0) {
              inp.value = val - 1;
              break;
            }
          }
        });
        syncGlobalTotal();
      } else if (DOM.globalQtyInput) {
        DOM.globalQtyInput.value = parseInt(DOM.globalQtyInput.value, 10) - 1;
        syncGlobalTotal();
      }
    });
  }

  function calculatePrice() {
    let currentQty = getTotalQuantity();
    let calcQty = currentQty < minQty ? minQty : currentQty;
    let currentUnitPrice = basePrice;
    
    if (priceTiers.length > 0) {
      const matchedTier = priceTiers.find(tier => calcQty >= tier.qty);
      if (matchedTier) currentUnitPrice = matchedTier.price;
    }

    let uploadedSidesCount = document.querySelectorAll('.pdi-dp-up-card.has-file').length;
    let extraSidesCost = 0;
    if (uploadedSidesCount > 1) {
      extraSidesCost = (uploadedSidesCount - 1) * 1.00;
    }

    let maxiCount = document.querySelectorAll('.pdi-dp-size-checkbox:checked').length;
    
    currentUnitPrice += (maxiCount * 2.00) + extraSidesCost;

    const totalPrice = currentUnitPrice * currentQty;
    
    calculatedUnitPrice = currentUnitPrice;
    calculatedTotalPrice = totalPrice;

    if(DOM.unitPriceEl) DOM.unitPriceEl.textContent = formatEuro(currentUnitPrice);
    if(DOM.totalPriceEl) DOM.totalPriceEl.textContent = formatEuro(totalPrice);
    
    updateDrawerBadges(currentQty);
  }

  const colorMap = {
    'nero':'#1a1a1a','black':'#1a1a1a','bianco':'#f5f5f5','white':'#f5f5f5','rosso':'#cc0000','red':'#cc0000',
    'blu':'#0033cc','blue':'#0033cc','navy':'#000080','blu navy':'#000080','verde':'#008000','green':'#008000',
    'giallo':'#ffd700','yellow':'#ffd700','oro':'#ffd700','grigio':'#808080','grey':'#808080','melange':'#a9a9a9',
    'arancione':'#ff8c00','orange':'#ff8c00','rosa':'#ffc0cb','pink':'#ffc0cb','fucsia':'#ff00ff','magenta':'#ff00ff',
    'azzurro':'#87ceeb','celeste':'#87ceeb','royal':'#4169e1','bordeaux':'#800000','burgundy':'#800000',
    'viola':'#800080','purple':'#800080','marrone':'#8b4513','brown':'#8b4513','beige':'#f5f5dc',
    'khaki':'#f0e68c','verde oliva':'#808000','olive':'#808000', 'lime': '#00ff00', 'turchese':'#40e0d0'
  };

  function getProductColorHex(cVal) {
    cVal = cVal.toLowerCase().trim();
    if (cVal.startsWith('#') && (cVal.length === 4 || cVal.length === 7)) return cVal;
    let mHex = colorMap[cVal];
    if (!mHex) { for (let key in colorMap) { if (cVal.includes(key)) { mHex = colorMap[key]; break; } } }
    return mHex || cVal;
  }

  function hexToRgb(hex) {
    if (!hex.startsWith('#')) return null;
    hex = hex.replace('#', '');
    if (hex.length === 3) hex = hex.split('').map(s => s + s).join('');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return { r, g, b };
  }

  function hexToRgba(hex, alpha) {
    const rgb = hexToRgb(hex);
    if (!rgb) return `rgba(0,0,0,${alpha})`;
    return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${alpha})`;
  }

  function getLuminance(hex) {
    const rgb = hexToRgb(hex);
    if (!rgb) return 0; 
    return (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
  }

  function updateDrawerBadges(qty = 0) {
    if(!DOM.badgesContainer) return;
    let badgesHTML = '';
    
    let activeRows = document.querySelectorAll('.pdi-dp-builder-row').length;
    if(activeRows > 0) { badgesHTML += `<span class="pdi-dp-badge">${activeRows} Combinazion${activeRows>1?'i':'e'}</span>`; }
    
    const sidesCount = document.querySelectorAll('.pdi-dp-up-card.has-file').length;
    if(sidesCount > 0) { badgesHTML += `<span class="pdi-dp-badge" style="background:var(--dp-m); color:#fff; border-color:var(--dp-m);">🖼️ ${sidesCount} Lat${sidesCount > 1 ? 'i' : 'o'}</span>`; }
    
    const maxiCount = document.querySelectorAll('.pdi-dp-size-checkbox:checked').length;
    if(maxiCount > 0) { badgesHTML += `<span class="pdi-dp-badge" style="background:var(--dp-y); color:#000; border-color:var(--dp-y);">⭐ ${maxiCount} Max</span>`; }
    
    if(qty > 0) { badgesHTML += `<span class="pdi-dp-badge" style="background:#fff; color:#000; border-color:#fff;">📦 ${qty} Pz</span>`; }

     DOM.badgesContainer.innerHTML = badgesHTML;
  }

  let rowIdCounter = 0;
  
  function createRow() {
    if(!DOM.builderContainer) return null;
    rowIdCounter++;
    const row = document.createElement('div');
    row.className = 'pdi-dp-builder-row';
    row.dataset.rowId = rowIdCounter;

    let colorGuide = rowIdCounter === 1 ? `<div class="pdi-dp-micro-guide pdi-dp-mg-white">👉 1. Seleziona il colore principale (cambierà l'anteprima in alto)</div>` : '';
    let sizeGuide = rowIdCounter === 1 ? `<div class="pdi-dp-micro-guide pdi-dp-mg-white" style="margin-top:15px; margin-bottom:20px;">👉 2. Inserisci le quantità desiderate per le varie taglie</div>` : '';

    let colorHtml = '';
    if (colorOptionValues.length > 0) {
      colorHtml = `<div class="pdi-dp-color-section">
                    ${colorGuide}
                    <span class="pdi-dp-row-title-block">Seleziona Colore:</span>
                    <div class="pdi-dp-swatches-wrap" data-opt-name="${colorOptionName}">`;
      colorOptionValues.forEach((cVal, idx) => {
        let hex = getProductColorHex(cVal);
        let activeClass = idx === 0 ? 'is-active' : '';
        colorHtml += `<div class="pdi-dp-swatch ${activeClass}" style="background-color: ${hex};" data-value="${cVal}" title="${cVal}"></div>`;
      });
      
      let prodTitleStr = DOM.productTitleMeta ? DOM.productTitleMeta.content : 'questo prodotto';
      let waTextObj = `Ciao, vorrei sapere se avete altri colori disponibili per ${prodTitleStr}.`;
      let waUrlLink = `https://wa.me/393713543866?text=${encodeURIComponent(waTextObj)}`;

      colorHtml += `</div>
                    <div class="pdi-dp-color-whatsapp-box">
                      <div class="pdi-dp-wa-info">
                        <strong>Non trovi il colore che cerchi?</strong>
                        Abbiamo selezionato i più comuni, ma se desideri altre tonalità possiamo ordinarle apposta per te.
                      </div>
                      <a href="${waUrlLink}" target="_blank" rel="noopener noreferrer" class="pdi-dp-wa-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.299 1.262.478 1.693.612.712.222 1.36.19 1.871.115.576-.084 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                        </svg>
                        Chiedi altri Colori
                      </a>
                    </div>
                  </div>`;
    }

    let sizesHtml = `<div class="pdi-dp-size-section">${sizeGuide}`;
    
    if (sizeOptions.length > 0) {
      sizeOptions.forEach(sizeOpt => {
        sizesHtml += `<div class="pdi-dp-size-sub-section">
                        <span class="pdi-dp-row-title-block">Seleziona ${sizeOpt.name} e Quantità:</span>
                        <div class="pdi-dp-size-grid">`;
        sizeOpt.values.forEach(sVal => {
          sizesHtml += `
            <div class="pdi-dp-size-card" data-size-name="${sizeOpt.name}" data-size-val="${sVal}">
              <span class="pdi-dp-size-label">${sVal}</span>
              <div class="pdi-dp-row-qty">
                <button type="button" class="pdi-dp-row-qbtn minus">-</button>
                <input type="number" class="pdi-dp-row-qinput" value="0" min="0" readonly>
                <button type="button" class="pdi-dp-row-qbtn plus">+</button>
              </div>
            </div>
          `;
        });
        sizesHtml += `</div></div>`;
      });
    } else {
      sizesHtml += `<div class="pdi-dp-size-sub-section">
                        <span class="pdi-dp-row-title-block">Seleziona Quantità:</span>
                        <div class="pdi-dp-size-grid">
                            <div class="pdi-dp-size-card" data-size-name="Quantità" data-size-val="Standard">
                              <span class="pdi-dp-size-label">Pezzi</span>
                              <div class="pdi-dp-row-qty">
                                <button type="button" class="pdi-dp-row-qbtn minus">-</button>
                                <input type="number" class="pdi-dp-row-qinput" value="0" min="0" readonly>
                                <button type="button" class="pdi-dp-row-qbtn plus">+</button>
                              </div>
                            </div>
                        </div>
                    </div>`;
    }
    
    sizesHtml += `</div>`;

    row.innerHTML = `
      ${colorHtml}
      ${sizesHtml}
      <button type="button" class="pdi-dp-row-del" title="Rimuovi Combinazione">✕ Rimuovi</button>
    `;

    DOM.builderContainer.appendChild(row);

    function updateRowBackgroundAndContrast(targetRow) {
      const activeSwatch = targetRow.querySelector('.pdi-dp-swatch.is-active');
      if (!activeSwatch) return;
      
      const colorVal = activeSwatch.dataset.value;
      const hex = getProductColorHex(colorVal);
      
      const colorStart = hexToRgba(hex, 0.85); 
      const colorEnd = hexToRgba(hex, 0.05);   

      targetRow.style.backgroundImage = `linear-gradient(135deg, ${colorStart} 0%, ${colorEnd} 100%)`;
      targetRow.style.backgroundColor = '#161821'; 
      
      const luminance = getLuminance(hex);
      if (luminance > 0.55) {
        targetRow.classList.add('is-dark-text');
      } else {
        targetRow.classList.remove('is-dark-text');
      }
    }

    updateRowBackgroundAndContrast(row);

    const swatches = row.querySelectorAll('.pdi-dp-swatch');
    swatches.forEach(sw => {
      sw.addEventListener('click', () => {
        triggerHaptic();
        swatches.forEach(s => s.classList.remove('is-active'));
        sw.classList.add('is-active');
        
        updateRowBackgroundAndContrast(row);
        
        if (row === DOM.builderContainer.firstElementChild) { updateMainImage(); }
      });
    });

    const qtyInputs = row.querySelectorAll('.pdi-dp-row-qinput');
    qtyInputs.forEach(inp => {
      const parent = inp.closest('.pdi-dp-row-qty');
      parent.querySelector('.minus').addEventListener('click', () => {
        triggerHaptic(); 
        let v = parseInt(inp.value, 10) - 1;
        if(v >= 0) { inp.value = v; syncGlobalTotal(); }
      });
      parent.querySelector('.plus').addEventListener('click', () => {
        triggerHaptic(); 
        inp.value = parseInt(inp.value, 10) + 1;
        syncGlobalTotal();
      });
    });

    const delBtn = row.querySelector('.pdi-dp-row-del');
    delBtn.addEventListener('click', () => {
      if(document.querySelectorAll('.pdi-dp-builder-row').length > 1) {
        triggerHaptic(); 
        row.remove(); 
        updateDeleteButtons(); 
        syncGlobalTotal();
        updateMainImage(); 
      }
    });

    updateDeleteButtons(); 
    if (rowIdCounter === 1) updateMainImage(); 
    return row;
  }

  function updateDeleteButtons() {
    const rows = document.querySelectorAll('.pdi-dp-builder-row');
    rows.forEach((r) => {
      const btn = r.querySelector('.pdi-dp-row-del');
      if(rows.length === 1) btn.style.display = 'none';
      else btn.style.display = 'block';
    });
  }

  function initializeRows() {
    if(!DOM.builderContainer) return;
    DOM.builderContainer.innerHTML = '';
    
    const firstRow = createRow(); 
    if (firstRow && minQty > 0) {
      firstRow.querySelectorAll('.pdi-dp-size-sub-section').forEach(sub => {
        let targetInputs = [];
        const preferredSizes = ['s', 'm', 'l']; 
        
        sub.querySelectorAll('.pdi-dp-size-card').forEach(card => {
          let sVal = (card.dataset.sizeVal || '').toLowerCase();
          if (preferredSizes.includes(sVal)) {
            targetInputs.push(card.querySelector('.pdi-dp-row-qinput'));
          }
        });

        if (targetInputs.length === 0) {
          targetInputs = Array.from(sub.querySelectorAll('.pdi-dp-row-qinput')).slice(0, 3); 
        }

        if (targetInputs.length > 0) {
          let base = Math.floor(minQty / targetInputs.length);
          let mod = minQty % targetInputs.length;
          targetInputs.forEach((inp, idx) => {
            inp.value = base + (idx < mod ? 1 : 0);
          });
        }
      });
    }
    syncGlobalTotal();
  }

  if(DOM.addRowBtn) {
    DOM.addRowBtn.addEventListener('click', () => { triggerHaptic(); createRow(); });
  }

  function updateMainImage() {
    const firstRow = document.querySelector('.pdi-dp-builder-row');
    let colorValue = null;
    
    if(firstRow) {
      const activeSwatch = firstRow.querySelector('.pdi-dp-swatch.is-active');
      if(activeSwatch) {
        colorValue = activeSwatch.dataset.value;
        const matchedVariant = variants.find(v => v.options && v.options.includes(colorValue));

        if (matchedVariant && DOM.mainImage && matchedVariant.featured_image && matchedVariant.featured_image.src) {
          DOM.mainImage.style.opacity = '0.5';
          setTimeout(() => { DOM.mainImage.src = matchedVariant.featured_image.src; DOM.mainImage.style.opacity = '1'; }, 150);
        }
      }
    }

    if (colorValue) {
      let finalColor = getProductColorHex(colorValue);
      document.querySelectorAll('.pdi-dp-user-canvas').forEach(canvas => { canvas.style.backgroundColor = finalColor; });
    }
  }

  const uploadCards = document.querySelectorAll('.pdi-dp-up-card');
  uploadCards.forEach(card => {
    const fileInput = card.querySelector('.pdi-dp-file-input');
    const userImg = card.querySelector('.pdi-dp-user-img'); 
    const removeBtn = card.querySelector('.pdi-dp-remove-file');
    const fileNameTxt = card.querySelector('.pdi-dp-file-name');
    const dpiWarning = card.querySelector('.pdi-dp-dpi-warning');
    if(!fileInput || !userImg || !removeBtn || !fileNameTxt) return;

    card.addEventListener('dragover', (e) => { e.preventDefault(); card.classList.add('is-dragover'); });
    card.addEventListener('dragleave', (e) => { e.preventDefault(); card.classList.remove('is-dragover'); });
    card.addEventListener('drop', (e) => {
      e.preventDefault(); card.classList.remove('is-dragover');
      if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        fileInput.files = e.dataTransfer.files;
        handleFileSelection(fileInput.files[0], card, userImg, fileNameTxt, removeBtn, dpiWarning);
      }
    });

    fileInput.addEventListener('change', function(e) {
      if (this.files[0]) { handleFileSelection(this.files[0], card, userImg, fileNameTxt, removeBtn, dpiWarning); }
    });

    removeBtn.addEventListener('click', () => {
      triggerHaptic();
      fileInput.value = ''; 
      userImg.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs='; 
      card.classList.remove('has-file'); 
      fileNameTxt.textContent = "Nessun file";
      removeBtn.style.display = 'none';
      if(dpiWarning) dpiWarning.style.display = 'none';
      
      const previewBlock = card.closest('.pdi-preview-block');
      if (previewBlock) {
        const maxiToggle = previewBlock.querySelector('.pdi-dp-size-checkbox');
        if(maxiToggle) { maxiToggle.checked = false; calculatePrice(); }
      }
      updatePositionData();
    });
  });

  document.querySelectorAll('.pdi-dp-size-checkbox').forEach(cb => {
    cb.addEventListener('change', () => { triggerHaptic(); calculatePrice(); });
  });

  function handleFileSelection(file, card, userImg, fileNameTxt, removeBtn, dpiWarning) {
    if (!file.type.startsWith('image/')) { alert("⚠️ Carica solo file immagine (PNG, JPG)."); return; }
    triggerHaptic();
    card.classList.add('has-file'); 
    fileNameTxt.textContent = "✅ " + file.name;
    
    const reader = new FileReader();
    reader.onload = function(event) { 
      userImg.src = event.target.result; 
      if(dpiWarning) {
        const img = new Image();
        img.onload = function() {
          if(img.width < 800 || img.height < 800) { dpiWarning.style.display = 'block'; }
          else { dpiWarning.style.display = 'none'; }
        }
        img.src = event.target.result;
      }
    }
    reader.readAsDataURL(file);
    removeBtn.style.display = 'flex';
    updatePositionData();
  }

  function updatePositionData() {
    let selectedPositions = [];
    document.querySelectorAll('.pdi-dp-up-card.has-file').forEach(card => {
      const input = card.querySelector('.pdi-dp-file-input');
      if(input && input.dataset.posName) selectedPositions.push(input.dataset.posName);
    });
    if(DOM.posInput) DOM.posInput.value = selectedPositions.join(' + ');
    calculatePrice(); 
  }

  function showError(msg) {
    if(!DOM.errorBox) return;
    DOM.errorBox.innerHTML = msg; DOM.errorBox.style.display = 'block';
    DOM.errorBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  function hideError() { if(DOM.errorBox) DOM.errorBox.style.display = 'none'; }

  function openStep(stepNum) {
    hideError(); triggerHaptic();
    if(DOM.progressBar) DOM.progressBar.style.width = (stepNum * 50) + '%';
    
    if(DOM.drawer) {
      if(stepNum === 2) { DOM.drawer.classList.add('show-cart-btn'); } 
      else { DOM.drawer.classList.remove('show-cart-btn'); }
    }

    document.querySelectorAll('.pdi-dp-step').forEach(step => {
      if(parseInt(step.dataset.step) === stepNum) {
        step.classList.remove('is-collapsed', 'is-dimmed');
        step.classList.add('is-active');
        setTimeout(() => { 
          const offset = window.innerWidth > 980 ? 40 : 10;
          const y = step.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({top: y, behavior: 'smooth'});
        }, 300);
      } else {
        step.classList.add('is-collapsed', 'is-dimmed');
        step.classList.remove('is-active');
      }
    });
  }

  function markStepCompleted(stepNum, summaryText) {
    const step = document.querySelector(`.pdi-dp-step[data-step="${stepNum}"]`);
    if(step) {
      step.classList.add('is-completed');
      const summaryObj = document.getElementById(`summary-step-${stepNum}`);
      if(summaryObj) summaryObj.innerHTML = `✅ ${summaryText}`;
    }
  }

  document.getElementById('btnNext1')?.addEventListener('click', () => {
    let totalQ = getTotalQuantity();
    if (totalQ < minQty) { showError(`⚠️ Per procedere devi raggiungere il minimo d'ordine di ${minQty} pezzi.`); return; }
    
    let rowsCount = document.querySelectorAll('.pdi-dp-builder-row').length;
    let summaryText = `${totalQ} Pezzi in ${rowsCount} combinazion${rowsCount>1?'i':'e'}`;

    markStepCompleted(1, summaryText); 
    openStep(2);
  });

  document.getElementById('btnPrev2')?.addEventListener('click', () => { openStep(1); });
  document.querySelectorAll('.pdi-dp-edit-btn').forEach(btn => {
    btn.addEventListener('click', (e) => { openStep(parseInt(e.target.dataset.target)); });
  });

  /* =======================================================
     CARRELLO: CHIAMATE SEQUENZIALI 
     ======================================================= */
  const customizerForm = document.getElementById('pdi-customizer-form');
  if (customizerForm) {
    customizerForm.addEventListener('submit', async (e) => {
      e.preventDefault(); hideError();
      
      const filesUploaded = document.querySelectorAll('.pdi-dp-up-card.has-file').length;
      if (filesUploaded === 0) { showError("⚠️ Manca la grafica! Carica almeno un file nei lati disponibili."); return; }

      let totalQ = getTotalQuantity();
      if (totalQ < minQty) { showError(`⚠️ L'ordine minimo è di ${minQty} pezzi.`); return; }

      let baseVariantId = null;
      let sizeBreakdown = [];
      let hasError = false;

      document.querySelectorAll('.pdi-dp-builder-row').forEach(row => {
        let selectedColor = "Base";
        const activeSwatch = row.querySelector('.pdi-dp-swatch.is-active');
        if(activeSwatch) selectedColor = activeSwatch.dataset.value;
        
        let rowQtyMap = {}; 
        let hasQtyInRow = false;

        row.querySelectorAll('.pdi-dp-size-card').forEach(sizeCard => {
          let sizeOptName = sizeCard.dataset.sizeName;
          let sizeVal = sizeCard.dataset.sizeVal;
          let qty = parseInt(sizeCard.querySelector('.pdi-dp-row-qinput').value, 10);
          
          if (qty > 0) {
            hasQtyInRow = true;
            if(!rowQtyMap[qty]) rowQtyMap[qty] = [];
            rowQtyMap[qty].push(`${sizeOptName}: ${sizeVal}`);
          }
        });

        if(hasQtyInRow) {
            let matchedVariant = variants[0];
            if(activeSwatch) {
                matchedVariant = variants.find(v => v.options && v.options.includes(selectedColor));
                if(!matchedVariant) { hasError = true; }
            }
            if(matchedVariant && !baseVariantId) baseVariantId = matchedVariant.id; 
            
            for (const [qty, sizesArr] of Object.entries(rowQtyMap)) {
              if(activeSwatch) {
                  sizeBreakdown.push(`${qty}x [${selectedColor}] ${sizesArr.join(' + ')}`);
              } else {
                  sizeBreakdown.push(`${qty}x ${sizesArr.join(' + ')}`);
              }
            }
        }
      });

      if(hasError || !baseVariantId || sizeBreakdown.length === 0) {
        showError("❌ Seleziona almeno una combinazione valida di taglie. Controlla lo Step 1.");
        openStep(1); return;
      }

      if(DOM.cartLoader) DOM.cartLoader.style.display = 'flex';
      if(DOM.addBtn) { DOM.addBtn.disabled = true; DOM.addBtn.textContent = 'Elaborazione...'; }
      
      try {
        const routesRoot = window.Shopify?.routes?.root || '/';
        let payloadFormData = new FormData();

        const noteVal = document.getElementById('pdiNotes')?.value;
        const latiVal = DOM.posInput ? DOM.posInput.value : '';
        const extraFeeId = DOM.extraFeeMeta ? DOM.extraFeeMeta.content : null;

        const bundleId = 'PDI_' + Date.now().toString(36);

        payloadFormData.append('id', baseVariantId);
        payloadFormData.append('quantity', totalQ);
        payloadFormData.append('properties[Dettaglio Taglie]', sizeBreakdown.join(' | '));
        payloadFormData.append('properties[_BundleID]', bundleId);
        
        if(noteVal) payloadFormData.append('properties[Note]', noteVal);
        if(latiVal) payloadFormData.append('properties[Lati da Stampare]', latiVal);

        document.querySelectorAll('.pdi-dp-up-card.has-file').forEach(card => {
          const fileInp = card.querySelector('.pdi-dp-file-input');
          if(fileInp && fileInp.files[0]) {
            const posName = fileInp.dataset.posName || 'Custom';
            payloadFormData.append(`properties[Grafica ${posName}]`, fileInp.files[0]);

            const previewBlock = card.closest('.pdi-preview-block');
            if (previewBlock) {
              const maxiCb = previewBlock.querySelector('.pdi-dp-size-checkbox');
              if(maxiCb && maxiCb.checked) {
                payloadFormData.append(`properties[Formato Max (${posName})]`, maxiCb.value);
              }
            }
          }
        });

        const res1 = await fetch(routesRoot + 'cart/add.js', { method: 'POST', body: payloadFormData });
        if (!res1.ok) {
          const errData = await res1.json();
          throw new Error("Prodotto Principale rifiutato: " + (errData.description || errData.message));
        }

        let baseVariantPrice = basePrice;
        const matchedVariantForPrice = variants.find(v => String(v.id) === String(baseVariantId));
        if (matchedVariantForPrice) { baseVariantPrice = matchedVariantForPrice.price / 100; }

        let diff = calculatedTotalPrice - (baseVariantPrice * totalQ);

        if (diff > 0.009 && extraFeeId && extraFeeId.trim() !== '') {
            let centsQty = Math.round(diff * 100); 
            
            const res2 = await fetch(routesRoot + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                items: [{
                  id: parseInt(extraFeeId.trim(), 10),
                  quantity: centsQty,
                  properties: { 
                    '_BundleID': bundleId 
                  }
                }]
              })
            });

            if(!res2.ok) {
               const errData2 = await res2.json();
               console.error("Errore aggiunta centesimi:", errData2);
               throw new Error(`Integrazione rifiutata. Controlla il Prodotto a 0,01€: ${errData2.description || errData2.message}`);
            }
        }

        window.location.href = routesRoot + 'cart';
        
      } catch (error) {
        if(DOM.cartLoader) DOM.cartLoader.style.display = 'none';
        if(DOM.addBtn) { DOM.addBtn.disabled = false; DOM.addBtn.textContent = 'Riprova 🛒'; }
        showError("❌ Errore Carrello: " + error.message);
      }
    });
  }

  initializeRows();
  
  if(DOM.progressBar) DOM.progressBar.style.width = '50%';
});